import { SvgIcon, SvgIconProps } from '@mui/material';
import { keyframes } from '@emotion/css';

const pulsate = keyframes`
  0% {
    opacity: 0.1;
    stroke: #141E55;
    stroke-width: 2;
  }

  100% {
    opacity: 1;
    stroke: #2C3566;
    stroke-width: 3;
  }
`;

export const MigrationArrows = ({ sx, ...restProps }: SvgIconProps) => (
  <SvgIcon
    viewBox="0 0 59 32"
    titleAccess="arrows"
    sx={{
      '& .icon1': {
        animation: `${pulsate} 0.533s ease-in infinite alternate`,
      },
      '& .icon2': {
        animation: `${pulsate} 0.533s ease-in infinite alternate`,
        animationDelay: '0.266s',
      },
      '& .icon3': {
        animation: `${pulsate} 0.533s ease-in infinite alternate`,
        animationDelay: '0.533s',
      },
      ...sx,
    }}
    {...restProps}
  >
    <path
      className="icon1"
      d="M1.5 4L13.5 16L1.5 28"
      stroke="#2C3566"
      strokeWidth="3"
      strokeLinecap="round"
      fill="none"
    />
    <path
      className="icon2"
      d="M23.5 4L35.5 16L23.5 28"
      stroke="#141E55"
      strokeWidth="2"
      strokeLinecap="round"
      fill="none"
    />
    <path
      className="icon3"
      d="M45.5 4L57.5 16L45.5 28"
      stroke="#141E55"
      strokeWidth="2"
      strokeLinecap="round"
      fill="none"
    />
  </SvgIcon>
);
